import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faTimes } from '@fortawesome/free-solid-svg-icons';
import DoarModal from './DoarModal';

const navLinks = [
  { href: '#home', label: 'Início' },
  { href: '#about', label: 'Sobre' },
  { href: '#lideranca', label: 'Liderança' },
  { href: '#schedules', label: 'Cultos' },
  { href: '#gcs', label: 'GCs' },
  { href: '#wecare', label: 'WeCare' },
  { href: '#sermons', label: 'Mensagens' },
  { href: '#contact', label: 'Contato' },
];

const MobileMenu = ({ isOpen, closeMenu }) => {
  const [isDoarModalOpen, setIsDoarModalOpen] = useState(false);

  const handleDoarClick = () => {
    closeMenu();
    setIsDoarModalOpen(true);
  };

  return (
    <>
      <div
        className={`md:hidden fixed top-20 right-4 z-50 w-64 rounded-2xl shadow-2xl
          bg-[#111827] border border-white/10
          transition-all duration-300 ease-out
          ${isOpen ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-3 pointer-events-none'}`}
      >
        <div className="flex justify-end p-3 pb-0">
          <button
            onClick={closeMenu}
            className="text-gray-500 hover:text-white p-1 focus:outline-none transition-colors"
            aria-label="Fechar menu"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="px-3 pb-4 space-y-0.5">
          {navLinks.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              onClick={closeMenu}
              className="block px-4 py-2.5 text-gray-300 hover:text-white hover:bg-white/5 rounded-xl text-sm font-medium transition-colors"
            >
              {label}
            </a>
          ))}

          <div className="pt-3 mt-1 space-y-2 border-t border-white/10">
            <a
              href="https://forms.clickup.com/9011854024/f/8cjbyp8-1191/TDTGOG3V0CF5K6PAOG"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-2.5 text-white bg-emerald-600 hover:bg-emerald-500 rounded-xl text-sm font-semibold text-center transition-colors"
            >
              Sou Visitante
            </a>
            <button
              onClick={handleDoarClick}
              className="w-full flex items-center justify-center gap-1.5 px-4 py-2.5 text-gray-900 bg-yellow-500 hover:bg-yellow-400 rounded-xl text-sm font-bold transition-colors"
            >
              Ofertar <FontAwesomeIcon icon={faHeart} className="text-xs" />
            </button>
          </div>
        </div>
      </div>

      <DoarModal
        isOpen={isDoarModalOpen}
        onClose={() => setIsDoarModalOpen(false)}
      />
    </>
  );
};

export default MobileMenu;
